import * as React from 'react';

// Redux
import { useSelector } from 'react-redux';

// Material UI
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';

// Material Icons
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';

// Constants
import IMAGE from 'constants/images';

// Types
import { ApplicationState } from 'store';

// Components
import Badge from 'components/Badge';

// Styles
import useStyles from './SearchAsyncComponent.styles';

interface SearchInterface {
  disabled?: boolean;
  placeholder?: string;
  inputSize?: 'small' | 'medium';
  classes?: {
    root?: string;
    container?: string;
  };
  loading?: boolean;
  totalCountValue?: number;
  onChange: (text: string) => void;
  value: string;
  body?: React.ReactElement | React.ReactNode;
  openModal?: boolean;
  setOpenModal?: (value: boolean) => void;
  modalFilter?: () => void;
}

type Props = SearchInterface;

const SearchAsyncComponent: React.FC<Props> = ({
  disabled,
  placeholder,
  classes,
  inputSize,
  loading,
  totalCountValue,
  onChange,
  value,
  body,
  openModal,
  modalFilter,
  setOpenModal,
}) => {
  const { total, flex, newStyle } = useStyles();

  const filterItems = useSelector(
    (state: ApplicationState) => state.reports.filterItems,
  );

  return (
    <Grid
      item
      lg={6}
      md={12}
      sm={12}
      xl={6}
      xs={12}
      className={classes?.container}>
      <Grid
        alignItems='center'
        container
        justifyContent='flex-start'
        spacing={1}>
        {body && (
          <Grid item>
            <Tooltip
              title='Adicionar mais itens pra pesquisa'
              placement='top'
              arrow>
              <IconButton
                disabled={disabled}
                onClick={() => {
                  if (setOpenModal instanceof Function) {
                    setOpenModal(true);
                  }
                }}>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
        <Grid item className={flex}>
          <FormControl>
            <TextField
              disabled={disabled}
              size={inputSize || 'medium'}
              className={newStyle}
              classes={{
                root: classes?.root,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon fontSize='small' />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='end'>
                    {modalFilter instanceof Function && (
                      <Box position='relative'>
                        <IconButton disabled={disabled} onClick={modalFilter}>
                          <img src={IMAGE.ICONS.FILTORS} alt='filters' />
                        </IconButton>
                        {filterItems?.length > 0 ? (
                          <Badge value={filterItems.length} />
                        ) : null}
                      </Box>
                    )}
                  </InputAdornment>
                ),
              }}
              placeholder={placeholder || 'Pesquisar'}
              variant='outlined'
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
          </FormControl>

          {loading ? (
            <CircularProgress
              color='primary'
              size={20}
              style={{ marginLeft: 8 }}
            />
          ) : (
            <>
              {totalCountValue && !disabled ? (
                <Typography className={total}>
                  {`${totalCountValue} resultados`}
                </Typography>
              ) : null}
            </>
          )}
        </Grid>
        <Dialog
          open={Boolean(openModal)}
          aria-labelledby='dialog filter'
          fullWidth
          onClose={() => {
            if (setOpenModal instanceof Function) {
              setOpenModal(false);
            }
          }}>
          <DialogTitle id='dialog-filter'>Pesquisar por:</DialogTitle>
          <DialogContent>{body}</DialogContent>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default SearchAsyncComponent;
export { SearchAsyncComponent };
